import React from 'react'
import { styled } from '@mui/material/styles'
import { Grid } from '@mui/material'
import Skeleton from '@mui/material/Skeleton'

const PREFIX = 'SkeltonArticleView'

const classes = {
  marginTopSpacing1: `${PREFIX}-marginTopSpacing1`,
}

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.marginTopSpacing1}`]: {
    marginTop: theme.spacing(1),
  },
}))

export const SkeltonArticleView = () => (
  <StyledGrid alignItems="center" container={true} direction="column" justifyContent="center">
    {[...new Array(20)].map((row) => (
      <Skeleton
        key={row}
        className={classes.marginTopSpacing1}
        variant="rectangular"
        height={12}
        width="100%"
      />
    ))}
  </StyledGrid>
)
